import { UpPedometer } from '../nebula-class/modules/uppedometer';
import './upAppinfoModule';
export default new UpPedometer();